module.exports = __webpack_public_path__ + "img/aichi.37dc47af.png";